(function() {
    'use strict';

    angular
        .module('atheer.user', [

        ]);
})();
